// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"Sh","place_order_copy":"Th","next_order_copy":"Uh","title_wrapper":"Vh","get_it_now_row":"Wh","get_it_now_remaining_items":"Xh","get_it_now_remaining_items_mob":"Yh","order_summary":"Zh","additional_items":"ai","account_content_slider":"bi","ingredient_carousel":"ci","ingredient_carouselwrapper":"ei","account_content_slide":"fi","account_subscription_section_mob":"gi","carouselwrapper":"hi"};
    if(module.hot) {
      // 1713969922573
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  